module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gcelO"))).then(() => parcelRequire('ljYL6'));